import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { map } from 'rxjs';
import { BaseComponent } from '@core/base/base-component';

@Component({
  selector: 'app-my-forms-google-error-page',
  imports: [RouterLink],
  template: `
    <div class="flex min-h-screen items-center justify-center bg-white px-4 font-inter">
      <div class="w-full max-w-md rounded-3xl border border-slate-200 p-8 text-center shadow-sm">
        <h1 class="text-h4 text-slate-950">Google sign-in failed</h1>
        <p class="mt-2 text-body2 text-slate-500">
          {{ message() }}
        </p>
        <a
          routerLink="/my-forms"
          class="mt-6 inline-flex rounded-xl bg-slate-900 px-4 py-2.5 text-body2 font-medium text-white">
          Try again
        </a>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyFormsGoogleErrorPage extends BaseComponent {
  private readonly code = toSignal(
    this.route.queryParamMap.pipe(map((params) => params.get('code') ?? 'oauth_failed')),
    { initialValue: 'oauth_failed' },
  );

  readonly message = computed(() => {
    switch (this.code()) {
      case 'oauth_denied':
        return 'Google sign-in was cancelled.';
      case 'missing_ticket':
        return 'Missing login ticket. Please try again.';
      case 'exchange_failed':
        return 'We could not complete sign-in. Please try again.';
      default:
        return 'Something went wrong during Google sign-in.';
    }
  });
}
